import { render, staticRenderFns } from "./AgencyOverviewAgentsTable.vue?vue&type=template&id=ea22bae8&"
import script from "./AgencyOverviewAgentsTable.vue?vue&type=script&lang=js&"
export * from "./AgencyOverviewAgentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgencyOverviewAgentsTable.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardActions,
  VDataTable,
  VSpacer,
})
